export default [

    //盈利测算
    {
        path: '/xiangmu/entertwo',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/entertwo.vue')
    },

    //玉鑫修改版
    {
        path: '/xiangmu/enterthree',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterthree.vue')
    },

    //工具类版
    {
        path: '/xiangmu/enterfour',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterfour.vue'),
        meta: {
            title: '工具版',
            isTabsPage: true,
            keepAlive:true
        }
    },

    //财务版
    {
        path: '/xiangmu/enterfive',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterfive.vue')
    },

    //海外版
    {
        path: '/xiangmu/entersix',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/entersix.vue')
    },

    //海外工具版
    {
        path: '/xiangmu/enterseven',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterseven.vue'),
        meta: {
            title: '海外工具版',
            isTabsPage: true,
            keepAlive:false
        }
    },


    //海外只计算(财务)
    {
        path: '/xiangmu/enternine',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enternine.vue'),
        meta: {
            title: '外销财务工具',
            isTabsPage: true,
            keepAlive:false
        }
    },

    //国内只计算(财务)
    {
        path: '/xiangmu/enterten',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterten.vue'),
        meta: {
            title: '内销财务工具',
            isTabsPage: true,
            keepAlive:false
        }
    },

    //损益操作表
    {
        path: '/rateSunyicaozuobiao',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/rateSunyicaozuobiao.vue'),
        meta: {
            title: '损益信息表',
            isTabsPage: true,
            keepAlive:true
        }
    },

    //公式维护表
    {
        path: '/jichugongshiweihu',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/jichugongshiweihu.vue'),
        meta: {
            title: '基础公式维护',
            isTabsPage: true,
            keepAlive:true
        }
    },

    //内销改数公式维护表
    {
        path: '/jichugongshiweihuneixiaogaishu',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/jichugongshiweihuneixiaogaishu.vue')
    },


    //租赁测算
    {
        path: '/rateFormulaZulinshiti',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/rateFormulaZulinshiti.vue'),
        meta: {
            title: '租赁测算',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //冷库内销
    {
        path: '/xiangmu/enterlengku-nx',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterlengku-nx.vue'),
        meta: {
            title: '冷库内销',
            isTabsPage: true,
            keepAlive:true
        }
    },
     //冷库内销审批
    {
        path: '/xiangmu/enterlengku-nxsp',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterlengku-nxsp.vue')
    },
    //冷库外销
    {
        path: '/xiangmu/enterlengku-wx',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterlengku-wx.vue'),
        meta: {
            title: '冷库外销',
            isTabsPage: true
        }
    },
    //测算版本列表
    {
        path: '/rvlistshow',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/rvlistshow.vue'),
        meta: {
            title: '测算版本列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    //特价列表
    {
        path: '/enterpricenew',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/enterpricenew.vue'),
        meta: {
            title: '特价列表',
            isTabsPage: true,
            keepAlive:true
        }
    },


]


